import { Alert } from '@mui/material';
import { Routes } from 'constants/pages';
import * as React from 'react';
import { Link } from 'react-router-dom';

export const Success: React.FC = () => {
  return (
    <div className="max-w-[744px] flex flex-col items-center space-y-8">
      <Alert severity="success">
        <div className="space-y-1">
          <h4 className="font-bold">Reset Password Email Sent</h4>
          <h4>
            We just sent an email containing a temporary link to reset your password. Please check
            you spam folder if the email doesn’t appear within a few minutes. If you still need
            help, just{' '}
            <a href="mailto:contact@bluecargo.io" className="text-blue-900">
              contact us
            </a>
            .
          </h4>
        </div>
      </Alert>
      <Link to={Routes.SignIn} className="text-blue-900">
        Sign in
      </Link>
    </div>
  );
};
